"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProfilePicturePath = void 0;
function getProfilePicturePath(userId, leadingSlash = true) {
    return `${leadingSlash ? '/' : ''}user/${userId}/profile/original`;
}
exports.getProfilePicturePath = getProfilePicturePath;
//# sourceMappingURL=getProfilePicturePath.js.map